import type { IconSvgObject } from './types';

const PenConnectBluetoothIcon: IconSvgObject = [
  ["path", { d: "M2 10L9 4L5.50081 2V12L9 10L2 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 8L20 11M18.4059 6.61664L7.96439 17.0582C7.32842 17.6942 6.87725 18.491 6.65911 19.3636L6 22L8.63644 21.3409C9.50899 21.1228 10.3058 20.6716 10.9418 20.0356L21.3834 9.59407C22.2055 8.77188 22.2055 7.43884 21.3834 6.61664C20.5612 5.79445 19.2281 5.79445 18.4059 6.61664Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PenConnectBluetoothIcon;
